import { normalizeId } from './id-utils.js';

export const mergeCharacters = (existing, updated) => {
  const merged = [...existing];
  const timestamp = new Date().toISOString();

  updated.forEach((newChar) => {
    const index = merged.findIndex((c) => normalizeId(c.id) === normalizeId(newChar.id));
    if (index !== -1) {
      merged[index] = {
        ...merged[index],
        ...newChar,
        name: newChar.name || merged[index].name,
        updatedAt: timestamp
      };
    } else {
      merged.push({ ...newChar, updatedAt: timestamp });
    }
  });
  return merged;
};

export const hasCharacterStateChanged = (currentCharacters, newCharacters) => {
  if (currentCharacters.length !== newCharacters.length) return true;
  for (let i = 0; i < currentCharacters.length; i++) {
    const current = currentCharacters[i];
    const next = newCharacters[i];
    if (normalizeId(current.id) !== normalizeId(next.id)
      || String(current.outfitId || 0) !== String(next.outfitId || 0)
      || (current.actionId ?? null) !== (next.actionId ?? null)) {
      return true;
    }
  }
  return false;
};

export const hasIdCollectionChanged = (currentItems, nextItems) => {
  const current = Array.isArray(currentItems) ? currentItems : [];
  const next = Array.isArray(nextItems) ? nextItems : [];
  if (current.length !== next.length) return true;
  return current.some((item, index) => normalizeId(item?.id) !== normalizeId(next[index]?.id));
};
